import { render, staticRenderFns } from "./changeRights.vue?vue&type=template&id=236c4df2&scoped=true"
import script from "./changeRights.vue?vue&type=script&lang=js"
export * from "./changeRights.vue?vue&type=script&lang=js"
import style0 from "./changeRights.vue?vue&type=style&index=0&id=236c4df2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236c4df2",
  null
  
)

export default component.exports